import AddBusinessTabScreen from "components/business/AddBusinessFleetPageComponent/AddBusinessTabScreen";
import AddFleetTabScreen from "components/business/AddBusinessFleetPageComponent/AddFleetTabScreen";
import UserContext from "Context/UserProvider";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { 
    Box, 
    Typography, 
    Tabs,
    Tab,
    CircularProgress,
    Container,
    Paper,
    Alert
} from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";
import toast from 'react-hot-toast';

interface AddBusinessFleetPageProps {
    error?: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

function AddBusinessFleetPage({ error }: AddBusinessFleetPageProps) {
    const [businesses, setBusinesses] = useState([]) as any;
    const [categories, setCategories] = useState([]) as any;
    const { userInfo } = useContext(UserContext);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation() as any;
    const optionCategory = location.state?.optionCategory;
    const [activeTab, setActiveTab] = useState(optionCategory ? (optionCategory[0] === true ? 0 : 1) : 0);
    const { fetchWithAuth } = useApiService();

    // Use error prop if provided
    const [errorState, setErrorState] = error || [isError, setIsError];

    async function fetchBusinessInfo() {
        try {
            const response = await fetchWithAuth('/business/list', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    accountUuid: userInfo.accountUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch business info');
            }

            const res_json = await response.json();
            setBusinesses(res_json.businesses);
            setCategories(res_json.categories);
            setErrorState(false);
        } catch (error) {
            console.error('Error fetching business info:', error);
            setErrorState(true);
            toast.error('Failed to load business information');
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchBusinessInfo();
    }, []);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container 
            maxWidth={false}
            sx={{ 
                pt: 3,
                width: {
                    xs: '100%',    // Full width on mobile
                    sm: '100%',    // Full width on tablet
                    md: '66.67%',  // 2/3 width on medium screens
                    lg: '33.33%',  // 1/3 width on large screens
                },
                mx: 'auto'
            }}
        >
            <Paper 
                elevation={0} 
                sx={{ 
                    borderRadius: 1,
                    overflow: 'hidden',
                    pt: 3 // Add 24px padding above tabs
                }}
            >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={activeTab} 
                        onChange={handleTabChange}
                        variant="fullWidth"
                        sx={{
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 'medium',
                                fontSize: '1rem',
                            }
                        }}
                    >
                        <Tab label="Add Business" />
                        <Tab label="Add Fleet" />
                    </Tabs>
                </Box>

                <Box sx={{ p: 3 }}>
                    {activeTab === 0 && (
                        <AddBusinessTabScreen 
                            fetchBusinessInfo={fetchBusinessInfo} 
                            categories={categories} 
                        />
                    )}
                    {activeTab === 1 && (
                        <AddFleetTabScreen 
                            businesses={businesses} 
                        />
                    )}
                </Box>
            </Paper>
        </Container>
    );
}

export default AddBusinessFleetPage;
